import { ModuleWithProviders, NgModule } from '@angular/core';

import {
  DEFAULT_ADDONS_STRATEGY,
  ProductsModuleConfig
} from './products-module.config';
import { ADDONS_STRATEGY } from './services/addons-helper.service';

@NgModule()
export class ProductsModule {
  public static forRoot(
    config: ProductsModuleConfig = {}
  ): ModuleWithProviders<ProductsModule> {
    return {
      ngModule: ProductsModule,
      providers: [
        {
          provide: ADDONS_STRATEGY,
          useValue: config.addonsStrategy || DEFAULT_ADDONS_STRATEGY
        }
      ]
    };
  }
}
